import api from './client';

// GET /api/v1/me — full current-user profile, including the Intercom
// identity-verification payload (app_id, user_hash, user, companies).
export const fetchMe = () => api.get('/api/v1/me');
